var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},_vm._l(([0,1,2]),function(item){return _c('skeleton-loader',{key:item,staticClass:"loading-card",attrs:{"type":"article"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }